import { Button, Typography } from "@mui/material";
import { Formik } from "formik";
import moment from "moment";
import * as yup from "yup";
import FormikDatePicker from "../../../../commons/formik/FormikDatePicker";
import FormikTextField from "../../../../commons/formik/FormikTextField";
import CircularLoading from "../../../../commons/loading/CircularLoading";
import { StyledCoberturaViajeAlExterior } from "../../../../styled/Personal";

const validationSchema = (fechaMinima) => yup.object({
  fechaViajeDesde: yup
    .date()
    .required("Campo obligatorio")
    .nullable()
    .typeError("Fecha inválida")
    .test({
      name: "fechaViajeDesde",
      message: () => {
        const fechaMinimaIsToday = moment(fechaMinima).isSame(moment(), 'day');
        return fechaMinimaIsToday
          ? "La fecha desde debe ser mayor o igual a hoy"
          : `La fecha desde debe ser mayor o igual a ${moment(fechaMinima).format("DD/MM/YYYY")}`;
      },
      test: function (value) {
        return value && fechaMinima
          ? moment(value).isSameOrAfter(moment(fechaMinima), 'day')
          : true;
      },
    }),
  fechaViajeHasta: yup
    .date()
    .required("Campo obligatorio")
    .nullable()
    .typeError("Fecha inválida")
    .test({
      name: "fechaViajeHasta-minima",
      message: "La fecha hasta no puede ser anterior a la fecha actual",
      test: function (value) {
        return value
          ? moment(value).isSameOrAfter(moment(), 'day')
          : true;
      },
    })
    .test({
      name: "fechaViajeHasta-desde",
      message: "La fecha hasta debe ser mayor o igual a la fecha desde",
      test: function (value) {
        return value && this.parent.fechaViajeDesde
          ? moment(value).isSameOrAfter(moment(this.parent.fechaViajeDesde), 'day')
          : true;
      },
    }),
  destino: yup
    .string()
    .required("Campo obligatorio")
    .max(255, "El campo debe contener maximo 255 caracteres"),
  coberturaSaludExterior: yup
    .string()
    .required("Campo obligatorio")
    .max(1000, "El campo debe contener maximo 1000 caracteres"),
});

const DatosDelViaje = ({ handleSubmit, formModel, fechaMinima }) => {

  return (
    <StyledCoberturaViajeAlExterior.Container>
      <StyledCoberturaViajeAlExterior.ContentContainer sx={{ margin: "auto" }}>
        {formModel ? (
          <Formik
            initialValues={formModel}
            validationSchema={validationSchema(fechaMinima)}
            onSubmit={handleSubmit}
          >
            <StyledCoberturaViajeAlExterior.Form>
              <div>
                <Typography>Fecha del Viaje</Typography>
                <StyledCoberturaViajeAlExterior.DatesInputContainer>
                  <StyledCoberturaViajeAlExterior.DatePicker>
                    <FormikDatePicker
                      name="fechaViajeDesde"
                      label="Fecha desde *"
                      ampm="false"
                      format="dd/MM/yyyy"
                      variant="inline"
                    />
                  </StyledCoberturaViajeAlExterior.DatePicker>
                  <StyledCoberturaViajeAlExterior.DatePicker>
                    <FormikDatePicker
                      name="fechaViajeHasta"
                      label="Fecha hasta *"
                      ampm="false"
                      format="dd/MM/yyyy"
                      variant="inline"
                    />
                  </StyledCoberturaViajeAlExterior.DatePicker>
                </StyledCoberturaViajeAlExterior.DatesInputContainer>
              </div>
              <FormikTextField
                fullWidth={true}
                id="destino"
                name="destino"
                type="text"
                label="Destino *"
                variant="outlined"
              />
              <FormikTextField
                fullWidth={true}
                id="coberturaSaludExterior"
                name="coberturaSaludExterior"
                type="text"
                label="Cobertura médica en el exterior *"
                variant="outlined"
              />
              <StyledCoberturaViajeAlExterior.ButtonContainer>
                <Button type="submit" color="primary" variant="contained">
                  Siguiente
                </Button>
              </StyledCoberturaViajeAlExterior.ButtonContainer>
            </StyledCoberturaViajeAlExterior.Form>
          </Formik>
        ) : (
          <CircularLoading />
        )}
      </StyledCoberturaViajeAlExterior.ContentContainer>
    </StyledCoberturaViajeAlExterior.Container>
  );
};

export default DatosDelViaje;
